import { api } from '.'
import { setStatusCode } from '../redux/statusCodeReducer'
import { setUser } from '../redux/userReducer'

const checkUser = () => {
  return api.get('api/user/getMe').then(response => response.data)
}

const getMe = () => {
  const xsrf = document.cookie.match(/^(.*;)?\s*XSRF-TOKEN\s*=\s*[^;]+(.*)?$/)

  if (!xsrf) {
    return api.get('/sanctum/csrf-cookie').then(() => {
      return checkUser()
    })
  }

  return checkUser()
}

// Enhanced function that handles Redux dispatch
const getMeWithDispatch = (dispatch) => {
  return getMe()
    .then((userData) => {
      if (userData?.id) {
        dispatch(
          setUser({
            id: userData.id,
            name: userData.name,
            email: userData.email,
            phone: userData.phone,
            roles: userData.roles,
            district: userData.district,
            udyam: userData.udyam,
          })
        );
      }
      return userData;
    })
}

const getStatusCodes = (dispatch) => {
  return api.get('/api/statusCode').then(response => {
    console.log(response)
    dispatch(setStatusCode(response.data))
  })
}

export { getMe, checkUser, getMeWithDispatch, getStatusCodes }
